import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import UserIcon from "@material-ui/icons/Person";
import ShoppingCartOutlined from "@material-ui/icons/ShoppingCartOutlined";
import Cookies from "js-cookie";
import ModalAccion from "../Generales/Modales/ModalAccion.jsx";
import Globales from "utils/Globales";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";
import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";
import { CircularProgress, Badge } from "@material-ui/core";
import { authApi } from "api/auth/index.js";
import { useUserStore } from "stores/userStore.js";

function VerificarIdentidad(props) {
	const { userState, setUser } = useUserStore();
	const { classes, dropdownHoverColor } = props;
	const [liveDemo, setLiveDemo] = useState(false);
	const [cargando, setCargando] = useState(true);
	const [Valido, setValido] = useState(false);
	const [mensaje, setMensaje] = useState("");
	const [TokenAuth0, setTokenAuth0] = useState("");

	const [params, setParams] = useState({});

	useEffect(() => {
		const procesarVerificacion = () => {
			let vinculacion = getParameterByName("Vinc") == "true" ? true : false;
			let expiraParam = getParameterByName("expira");
			let correo = getParameterByName("correo");
			let idTokenSocialNetwork = getParameterByName("idTokenSocialNetwork");
			let Nombre = getParameterByName("Nombre");

			if (!idTokenSocialNetwork || !correo) {
				setValido(false);
				setMensaje("Parámetros de verificación incompletos");
				setCargando(false);
				return;
			}

			setTokenAuth0(idTokenSocialNetwork);

			if (!expiraParam || isNaN(parseInt(expiraParam))) {
				setValido(false);
				setMensaje("Enlace de verificación inválido");
				setCargando(false);
				return;
			}

			let expira = new Date(parseInt(expiraParam));

			if (expira.getTime() < new Date().getTime()) {
				setValido(false);
				setMensaje("El enlace de verificación ha caducado");
				setCargando(false);
			} else {
				if (vinculacion) {
					VincularCuentas(idTokenSocialNetwork);
				} else {
					// let NombreUsuarioUnico = correo.split("@")[0] + idTokenSocialNetwork.split("|")[1]
					let NombreUsuarioUnico = correo.split("@")[0];
					let usuarioNuevo = {
						Nombre: Nombre ? Nombre : NombreUsuarioUnico,
						Correo: correo,
						TipoUsuario: "Cliente",
						ContrasenaRegistro: "",
						ConfirmacionContrasena: "",
						UsuarioRegistro: correo,
						idTokenSocialNetwork: idTokenSocialNetwork,
						TokenSocialNetwork: idTokenSocialNetwork,
						RedSocial: 0,
					};
					RegistrarUsuario(usuarioNuevo);
				}
			}
		};

		procesarVerificacion();
	}, []);

	function getParameterByName(name) {
		// Usar URLSearchParams para leer parámetros de la URL
		// Primero intentar desde window.location.search (URL principal)
		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.has(name)) {
			return searchParams.get(name);
		}

		// Si no está en search, intentar desde el hash (para compatibilidad con rutas con #)
		const hash = window.location.hash;
		if (hash && hash.includes("?")) {
			const hashParams = new URLSearchParams(hash.split("?")[1]);
			if (hashParams.has(name)) {
				return hashParams.get(name);
			}
		}

		// Si no se encuentra, retornar null
		return null;
	}
	const handleClickOpen = (modal) => {
		setLiveDemo({ [modal]: true });
	};

	const handleClose = (modal) => {
		setLiveDemo({ [modal]: false });
	};

	const openModal = () => {
		setLiveDemo(true);
	};

	const irMenuPrincipal = () => {
		setTimeout(() => {
			window.location.href = "/";
		}, 2000);
	};

	const eventoModal = (e) => {
		if (!e) {
			setLiveDemo(false);
			return;
		}
		// cerrarSesion();
	};

	const Login = async (token) => {
		try {
			let repuesta = await authApi.Auth({
				socialToken: token,
			});

			if (repuesta.success) {
				// La estructura de respuesta es: repuesta.data.user, repuesta.data.basket, repuesta.data.token
				const user =
					repuesta.data?.user || repuesta.data?.usuario || repuesta.usuario;
				const basket =
					repuesta.data?.basket ||
					repuesta.data?.carrito ||
					repuesta.carrito ||
					0;
				const tokenValue =
					repuesta.data?.token || repuesta.data?.Token || repuesta.token;

				if (!user) {
					setValido(false);
					setMensaje("Error al obtener datos del usuario");
					setCargando(false);
					return;
				}

				var sesion = {
					id: user._id,
					RedSocial: token,
					Carrito: basket,
					ListaCarrito: user.ListaCarrito || [],
					ListaDeseos: user.ListaDeseos || [],
					Usuario: user.Usuario,
					Nombre: user.Nombre,
					Correo: user.Correo,
					Telefono: user.Telefono || "",
					TipoUsuario: user.TipoUsuario,
					Token: tokenValue,
					IndicadorTerco: user.IndicadorTerco || false,
				};
				setUser(sesion);

				let dt = new Date();
				localStorage.setItem("expira", new Date(dt.getTime() + 20 * 60000));

				// Asociar diseños de sessionId a idCliente si existe sessionId
				const sessionId = localStorage.getItem("sessionId");

				if (sessionId && user._id) {
					// Validar que idCliente sea un ObjectId válido
					const isValidObjectId = /^[0-9a-fA-F]{24}$/.test(user._id);

					if (isValidObjectId) {
						try {
							const asociarResponse = await fetch(
								`${
									Globales.Url
								}DisenoProductos/DisenoProductos/AsociarDisenosASesion`,
								{
									method: "POST",
									headers: {
										"Content-Type": "application/json",
									},
									body: JSON.stringify({
										sessionId: sessionId,
										idCliente: user._id,
									}),
								}
							);

							const asociarData = await asociarResponse.json();

							if (!asociarData.error && asociarData.data?.cantidad > 0) {
								// Guardar el ID del último diseño asociado para cargarlo después
								if (
									asociarData.data.diseñosAsociados &&
									asociarData.data.diseñosAsociados.length > 0
								) {
									const ultimoDisenoId =
										asociarData.data.diseñosAsociados[
											asociarData.data.diseñosAsociados.length - 1
										];
									localStorage.setItem(
										"ultimoDisenoAsociado",
										ultimoDisenoId.toString()
									);
									localStorage.setItem("cargarDisenoDespuesLogin", "true");
								}
							}

							// Limpiar sessionId después de asociar
							localStorage.removeItem("sessionId");
						} catch (error) {
							// No bloquear el flujo si falla la asociación
							localStorage.removeItem("sessionId");
						}
					} else {
						// Si el idCliente no es válido, limpiar sessionId
						localStorage.removeItem("sessionId");
					}
				}

				// Verificar si viene del diseñador
				const returnToDiseñador = localStorage.getItem("returnToDiseñador");

				setCargando(false);
				setValido(true);
				setMensaje(
					repuesta.message ||
						repuesta.mensaje ||
						"Cuenta creada e iniciada correctamente"
				);

				setTimeout(() => {
					if (returnToDiseñador === "true") {
						// Limpiar el flag pero mantener la bandera de cargar diseño
						localStorage.removeItem("returnToDiseñador");
						// Redirigir de vuelta al diseñador
						window.location.href = window.location.origin + "/diseñador3D";
					} else {
						irMenuPrincipal();
					}
				}, 1000);
			} else {
				setValido(false);
				setMensaje(repuesta.message || "Error al iniciar sesión");
				setCargando(false);
			}
		} catch (error) {
			console.error("❌ Error en Login:", error);
			setValido(false);
			setMensaje(
				"Error al iniciar sesión: " + (error.message || "Error desconocido")
			);
			setCargando(false);
		}
	};

	const RegistrarUsuario = async (usuarioNuevo) => {
		try {
			let respuesta = await authApi.Create(usuarioNuevo);

			if (!respuesta.success) {
				setValido(false);
				setMensaje(respuesta.message || "Error al crear la cuenta");
				setCargando(false);
			} else {
				Login(usuarioNuevo.idTokenSocialNetwork);
			}
		} catch (error) {
			setValido(false);
			setMensaje(
				"Error al crear la cuenta: " + (error.message || "Error desconocido")
			);
			setCargando(false);
		}
	};

	const VincularCuentas = (token) => {
		fetch(
			Globales.Url +
				"UsuarioClientes/UsuarioClientes/ValidarVinculacionExitosa",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({ idTokenSocialNetwork: token }),
			}
		)
			.then((res) => res.json())
			.then((data) => {
				if (data.data != null) {
					setMensaje(data.mensaje);
					Login(token);
				} else {
					setValido(false);
					setMensaje(data.mensaje);
					setCargando(false);
				}
			})
			.catch((err) => console.error(err));
	};

	const eliminarTodasLasCookies = () => {
		const cookies = document.cookie.split(";");

		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i];
			const eqPos = cookie.indexOf("=");
			const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
		}

		localStorage.clear();
		sessionStorage.clear();
	};

	const CambiarRuta = (ruta) => {
		window.location.href = ruta;
	};

	const popover = {
		height: "calc(100vh - 60px)",
		width: "100vw",
		justifyContent: "center",
		alignItems: "center",
		display: "flex",
	};

	return (
		<div style={popover}>
			{cargando ? (
				<ListItem className={classes.listItem}>
					<CircularProgress
						size={70}
						thickness={5}
						style={{ color: "black" }}
					/>
				</ListItem>
			) : Valido ? (
				<div>
					<svg
						class="checkmark"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 52 52"
					>
						<circle
							class="checkmark__circle"
							cx="26"
							cy="26"
							r="25"
							fill="none"
						/>
						<path
							class="checkmark__check"
							fill="none"
							d="M14.1 27.2l7.1 7.2 16.7-16.8"
						/>
					</svg>
					<h3>{mensaje}</h3>
				</div>
			) : (
				<div>
					<div class="container_Error">
						<div class="circle_Error">
							<div class="error" />
						</div>
					</div>
					<h3>{mensaje}</h3>
				</div>
			)}
			<div id="">
				<ModalAccion
					Titulo="Cerrar Sesión"
					body={
						"¿Seguro que deseas cerrar sesión " +
						userState.Name +
						"?"
					}
					liveDemo={liveDemo}
					eventClick={eventoModal}
				/>
			</div>
		</div>
	);
}

export default withStyles(headerLinksStyle)(VerificarIdentidad);
